import { INITIAL_APPLICATION } from '@/utils/constants';

export default function () {
  return {
    application: { ...INITIAL_APPLICATION },
    applicationLoading: false,
    clearingApplication: false
  };
}
